import { PayloadAction } from "@reduxjs/toolkit";
import { CustomerState } from "../customer.slice.ts";
import { IncomeOtherRequest } from "../../../../orchestrator-api-client";

export const submitOtherIncomeReducer = (
  state: CustomerState,
  action: PayloadAction<IncomeOtherRequest>,
) => {
  state.job.income.hasOtherIncome = action.payload.hasOtherIncome;
  state.job.income.otherIncomeDescription =
    action.payload.otherIncomeDescription;
  state.job.income.otherIncomeNetMonthlySalary =
    action.payload.otherIncomeNetMonthlySalary;
};
